import React from 'react';
import PropTypes from 'prop-types';

/**
 * CurrentSubscriptionCard Component
 *
 * Displays current subscription status with management options.
 * Extracted from SubscriptionPlans for better organization.
 */
const CurrentSubscriptionCard = ({
    subscriptionData,
    isInGracePeriod,
    onOpenPortal,
    getStatusText,
    formatDate
}) => {
    // Don't render if no subscription or status is NONE
    if (!subscriptionData || subscriptionData.status === 'NONE') {
        return null;
    }

    const hasStripeCustomer = subscriptionData.hasStripeCustomer;

    return (
        <div
            className={`current-subscription ${subscriptionData.status.toLowerCase()} ${isInGracePeriod ? 'grace-period' : ''}`}
        >
            <h3>Twoja subskrypcja</h3>

            <div className="subscription-details">
                {/* Status */}
                <div className="detail">
                    <span className="label">Status:</span>
                    <span className={`value status-${subscriptionData.status.toLowerCase()}`}>
                        {getStatusText(subscriptionData.status)}
                        {isInGracePeriod && ' (okres karencji)'}
                    </span>
                </div>

                {/* End date / Next payment */}
                {subscriptionData.endDate && (
                    <div className="detail">
                        <span className="label">
                            {subscriptionData.status === 'ACTIVE'
                                ? 'Następna płatność:'
                                : 'Wygasa:'}
                        </span>
                        <span className="value">
                            {formatDate(subscriptionData.endDate)}
                        </span>
                    </div>
                )}

                {/* Days remaining */}
                {subscriptionData.daysRemaining !== undefined && (
                    <div className="detail">
                        <span className="label">Pozostało dni:</span>
                        <span className="value">{subscriptionData.daysRemaining}</span>
                    </div>
                )}
            </div>

            {/* Actions */}
            <div className="subscription-actions">
                {hasStripeCustomer && (
                    <button onClick={onOpenPortal} className="portal-btn">
                        Zarządzaj płatnościami
                    </button>
                )}
            </div>
        </div>
    );
};

CurrentSubscriptionCard.propTypes = {
    subscriptionData: PropTypes.shape({
        status: PropTypes.string.isRequired,
        endDate: PropTypes.string,
        daysRemaining: PropTypes.number,
        hasStripeCustomer: PropTypes.bool
    }),
    isInGracePeriod: PropTypes.bool,
    onOpenPortal: PropTypes.func.isRequired,
    getStatusText: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired
};

CurrentSubscriptionCard.defaultProps = {
    isInGracePeriod: false
};

export default CurrentSubscriptionCard;
